<span class="relative flex flex-col w-full h-full">
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium"><i class="fa-solid fa-user-lock mr-[10px]"></i> Velja annan notanda</div>
        <div class="absolute top-0 right-0 pt-4 pr-4">
            <button (click)="close()" mat-icon-button [matDialogClose]="undefined">
                <mat-icon class="white-color" [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
        </div>
    </div>
    <ng-container>
        <form [formGroup]="form" class="mx-8 mt-2 mb-4" [ngClass]="{'mt-4' : checkHasSelectoryRole()}">
            <div class="my-4 float-left">
                {{ checkHasSelectoryRole() ? '' : 'Hér getur þú óskað eftir umboði frá viðkomandi til að aðstoða hann/hana á innra
                vefsvæði LSR. Verði umboð veitt er þér tímabundið úthlutað sömu aðgangsheimild og viðkomandi.' }} @if
                (!checkHasSelectoryRole()) {
                <span class="mt-2 float-left">
                    Rafræn auðkenningarbeiðni verður send í farasíma viðkomandi sem þarf að veita samþykki sitt.
                </span>
                }
                <br />
            </div>
            <span id="valinnNotandi">
                <public-registry-search
                    label="Viðkomandi (Notandi)"
                    (onOptionSelected)="userSelected($event)"
                    [subtitle]="!checkHasSelectoryRole() ? 'Veldu notanda sem þú hyggst aðstoða' : null"
                    [hasError]="form?.get('ssn')?.hasError('required')"
                    [autofocus]="true"
                >
                </public-registry-search>
                <mat-form-field class="w-full mt-4">
                    <mat-label>Ástæða</mat-label>
                    <textarea matInput formControlName="reason" maxlength="1000" rows="4"></textarea>
                    @if (form?.get('reason')?.hasError('required')) {
                    <mat-error>Ástæðu vantar</mat-error>
                    }
                </mat-form-field>
                @if (checkHasSelectoryRole()) {
                <span class="float-left w-100 mt-3">
                    <mat-checkbox formControlName="fullImpersonation" class="ml-[10px] mb-2">
                        Óska eftir fullu umboði notanda
                    </mat-checkbox>
                </span>
                }
            </span>
            <span class="separator-line block"></span>
            <button (click)="submitRequest()" class="float-right px-6 mb-1 mt-1" mat-flat-button [color]="'primary'">
                @if (formEnabled) {
                <span>{{form.get('fullImpersonation').value ? 'Senda auðkenningarbeiðni' : 'Velja notanda' }}</span>
                } @if (!formEnabled) {
                <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                }
            </button>
        </form>
    </ng-container>
</span>
